export default [
	{
        path: '/service',
        name: 'cardService',
        component: () => import('pages/card-manage/service'),
    },
];